// ÜZENET-HATÓKÖR jelvény a partner-portálon — a jel a KÖZÖS badge-katalógusból (`domain-badge.tsx`,
// `messageScope`). A hatókör azt mondja, KI KAPTA a levelet: körlevél → megafon (mindenkinek) · a fiókjának →
// épület · személyesen Önnek → egy ember.
//
// MIÉRT KÜLÖN KOMPONENS: ugyanez a három jelvény a LISTA-soron ÉS a megnyitott üzenet panelján is megjelenik —
// a hívók egy névre szóló API-t kapnak, a térkép a katalógusban él. Ismeretlen hatókör → nincs jelvény (a
// portálon nem mutatunk semleges pöttyöt egy értelmezhetetlen értékre).
import { badgeVisual, DomainBadge } from '@/components/shared/domain-badge';

export interface MessageScopeBadgeProps {
  scope: string;
  label: string;
}

export function MessageScopeBadge({ scope, label }: MessageScopeBadgeProps): JSX.Element | null {
  if (badgeVisual('messageScope', scope) === undefined) return null;
  return <DomainBadge kind="messageScope" value={scope} label={label} />;
}
